<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Properties {
    panel: Snippet;
    map: Snippet;
    /** When false, hides the map region and lets the panel span the full width. */
    showMap?: boolean;
  }

  const { panel, map, showMap = true }: Properties = $props();
</script>

<!-- Side-panel + map two-pane shell. Map fills the left region, panel is a
     fixed-width column on the right. On narrow viewports the panel stacks
     above the map so the map still sits at the bottom of the screen. Tabs
     that don't need geographic context (departures) pass `showMap={false}`
     so the panel takes the full width. -->
<div class="layout" class:panel-only={!showMap}>
  <aside class="panel" aria-label="Search panel">
    {@render panel()}
  </aside>
  {#if showMap}
    <div class="map-region" aria-label="Map">
      {@render map()}
    </div>
  {/if}
</div>

<style>
  .layout {
    display: flex;
    flex-direction: row-reverse;
    height: 100vh;
    width: 100vw;
  }

  .panel {
    width: 380px;
    max-width: 100vw;
    overflow-y: auto;
    padding: var(--space-lg);
    background: var(--color-bg);
    border-left: 1px solid var(--color-border);
  }

  .layout.panel-only .panel {
    width: 100%;
    border-left: none;
  }

  .map-region {
    flex: 1;
    min-width: 0;
  }

  @media (width <= 768px) {
    .layout {
      display: block;
      height: auto;
    }

    .panel {
      width: 100%;
      max-height: none;
      overflow-y: visible;
      border-left: none;
      border-bottom: 1px solid var(--color-border);
    }

    .map-region {
      height: 60vh;
    }
  }
</style>
